import * as React from "react"
import { ThemeCss } from "gatsby-interface"
import { SiteSettingsSection } from "../constants"
import CopyUrl from "../../../ui/components/CopyUrl"
import { WebhookHelpLink } from "./WebhookHelpLink"

const wrapperCss: ThemeCss = theme => ({
  display: `flex`,
  flexDirection: `column`,
  gap: theme.space[5],
})

const titleWrapperCss: ThemeCss = theme => ({
  display: `flex`,
  justifyContent: `flex-start`,
  alignItems: `center`,
  gap: theme.space[3],
})

const titleCss: ThemeCss = theme => ({
  fontWeight: 600,
  fontSize: theme.fontSizes[3],
  margin: 0,
})

export type WebhookItemProps = {
  title: string
  url: string
  infoLinkUrl?: string
  type: SiteSettingsSection
}

export function WebhookItem({
  title,
  url,
  infoLinkUrl,
  type,
}: WebhookItemProps) {
  return (
    <div css={wrapperCss}>
      <div css={titleWrapperCss}>
        <h3 css={titleCss}>{title}</h3>
        {infoLinkUrl && <WebhookHelpLink url={infoLinkUrl} ariaLabel={title} />}
      </div>
      <CopyUrl url={url} data-cy-name={`${type}-url`} />
    </div>
  )
}
